import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

import { BLOCK_SECTION_BORDER_RADIUS } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/config/blockStyleConstants"
import { unusedHandlersAnimation } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/config/flowBlockAnimations"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(2),
		minHeight: theme.spacing(6),
		borderRadius: BLOCK_SECTION_BORDER_RADIUS,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[50])
	},
	textPlaceholder: {
		color: colors.gray[300]
	},
	title: {
		color: colors.blue[800]
	},
	information: {
		color: colors.gray[500],
		fontSize: theme.spacing(1.25)
	},
	...unusedHandlersAnimation
}))

export default useStyles
